import AppLayout from "../components/layout/AppLayout";
import WeightmentComponent from "../components/weightment/WeightmentComponent";

export default function WeightmentPage() {
  return (
    <AppLayout>
      <WeightmentComponent />
    </AppLayout>
  );
}
